import { combineReducers } from 'redux';
import { sharedJavascriptReducers } from '../shared-javascript/reducers';

const appReducer = combineReducers(Object.assign(sharedJavascriptReducers));

export { appReducer };
